/*
 * @Description: 说明
 * @Author: ninZhiYong
 * @Date: 2022-11-16 08:34:25
 */
import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
  baseURL: __APP_ENV__.VITE_APP_SSO_HOST_URL,
  // 超时
  timeout: 1000 * 60
})

export default service
